export function generateTaskCode(projectName: string, taskId: number): string {
  const words = projectName.trim().split(/\s+/);
  const prefix = words
    .map((w) => w.charAt(0).toUpperCase())
    .join("")
    .slice(0, 4);
  return `${prefix || "T"}-${taskId}`;
}

export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + "...";
}
